export interface AlainSEConfig {
  /**
   * å¤§å°ï¼é»è®¤ï¼`default`
   * - `compact` ç´§ååï¼å¼ºå¶å¿½ç¥ `error`ã`extra` å±ç¤º
   */
  size?: 'default' | 'compact';
  /**
   * å¸å±ç±»åï¼ç­å `nzLayout`ï¼é»è®¤ï¼`horizontal`
   * - `inline` æ¶å¼ºå¶å¤§å°ä¸º `compact`
   */
  nzLayout?: 'horizontal' | 'vertical' | 'inline';
  /**
   * é´è·ï¼å½ `nzLayout:horizontal` æ¶ææï¼é»è®¤ï¼`32`
   */
  gutter?: number;
  /**
   * åæ°ï¼é»è®¤ï¼`2`
   */
  col?: number;
  /**
   * æ ç­¾ææ¬å®½åº¦ï¼åä½ï¼`px`ï¼é»è®¤ï¼`150`
   */
  labelWidth?: number;
  /**
   * æ¯å¦ç«å³åç°éè¯¯è§è§ï¼é»è®¤ï¼`false`
   */
  firstVisual?: boolean;
}
